import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress React DOM errors in development (Radix UI portal conflicts)
const originalError = console.error;
console.error = (...args) => {
  const message = args[0]?.toString() || '';
  const suppressPatterns = [
    'removeChild',
    'insertBefore',
    'appendChild',
    'NotFoundError',
    'not a child of this node'
  ];
  
  if (suppressPatterns.some(pattern => message.includes(pattern))) {
    console.warn('Suppressed DOM error:', args[0]);
    return;
  }
  originalError.apply(console, args);
};

// Also handle unhandled errors at window level
window.addEventListener('error', (event) => {
  const message = event.message || event.error?.message || '';
  const suppressPatterns = [
    'removeChild',
    'insertBefore',
    'appendChild', 
    'NotFoundError',
    'not a child of this node'
  ];
  
  if (suppressPatterns.some(pattern => message.includes(pattern))) {
    event.preventDefault();
    console.warn('Suppressed window error:', message);
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
